<template>
    <form class="forget-form" v-on:submit.prevent="forgot">
        <div class="reset-image text-center">
            <img v-if="!forgotComplete" src="../../images/reset-image.svg" alt="">
            <img v-if="forgotComplete" src="../../images/reset-success-img.svg" alt="">
        </div>
        <h3 class="font-weight-bold" v-if="forgotComplete">{{ $t('Successfully!') }}</h3>
        <h3 class="font-weight-bold" v-if="!forgotComplete">{{ $t('Forgot Password') }}?</h3>
        <!-- <b-alert v-if="forgotComplete" dismissible fade variant="success" show>{{ $t('Thank you, the password recovery link was sent to your email address') }}.</b-alert> -->
        <div class="d-flex justify-content-center">
            <p class="bottom-tip" v-if="forgotComplete">{{ $t('The password recovery link was sent to your email address') }}.</p>
            <p class="bottom-tip" v-if="!forgotComplete">{{ $t('Please enter your email address below to reset your password') }}.</p>
        </div>
        
        <div :class="{ 'has-error' : errors.has('formForgot.email') }" class="input-wrapper form-group" v-if="!forgotComplete">
            <label class="form-control-placeholderl"> {{ $t('E-mail') }} <span>*</span></label>
            <input v-model.trim="formForgot.email"
                   v-validate="'required|email|emailExist'"
                   :data-vv-as="$t('E-mail')"
                   data-vv-delay="1000"
                   class="form-control form-control-solid"
                   name="formForgot.email"
                   type="text"
                   maxlength="100">
            <span v-show="errors.has('formForgot.email')" id="forgot-email-tooltip" class="help-block alt"><span class="error-sign"></span></span>
            <b-tooltip ref="tooltip-forgot-email" target="forgot-email-tooltip" placement="top" >{{errors.first('formForgot.email')}}</b-tooltip>
        </div>
        <div :class="{ 'has-error' : !reCaptcha.verify }" class="form-group mt-20" v-if="!forgotComplete">
            <div>
                <vue-recaptcha
                        ref="recaptcha"
                        :sitekey="reCaptcha.siteKey"
                        @verify="onCaptchaVerify"
                        @expired="onCaptchaExpired"
                />
            </div>
            <span v-if="!reCaptcha.verify" id="forgot-сaptcha-tooltip" class="help-block alt"><span class="error-sign"></span></span>
            <b-tooltip ref="tooltip-forgot-captcha" target="forgot-сaptcha-tooltip" placement="top" >{{ $t('Please, confirm that you are not a robot.') }}</b-tooltip>
        </div>
        <div class="form-actions" v-if="!forgotComplete">
            <button type="button" @click="clickToBack(!isForgotPass)" class="button">{{ $t('Back') }}</button>
            <button :disabled="forgotComplete" class="button primary pull-right">{{ $t('Reset Password') }}</button>
        </div>
        <div class="form-actions text-center" v-if="forgotComplete">
            <button type="button" @click="clickToBack(!isForgotPass)" class="button primary">{{ $t('Back to Login') }}</button>
        </div>
    </form>
</template>

<script>

    import VueRecaptcha from "vue-recaptcha";

    export default {
        name: 'forgot',
        components: {
            VueRecaptcha,
        },
        props: {
            isForgotPass: {
                type: Boolean
            }
        },
        data: function () {
            return {
                // isProd: process.env.VUE_APP_ENV === 'production',
                forgotComplete: false,
                reCaptcha: {
                    siteKey: process.env.VUE_APP_RECAPTCHA_SITEKEY,
                    verify: false
                },
                formForgot: {
                    email: '',
                },
            }
        },
        watch: {

        },
        computed: {

        },
        created () {
            this.$validator.localize('en', {
                attributes: {
                    'formForgot.email': 'Email',
                },
                custom: {
                    formForgot:{
                        email: {
                        required: "Please enter a valid email address (e.g. john@site.com).",
                        email: "Please enter a valid email address (e.g. john@site.com).",
                        emailExist: "This Email is not registered.",
                       },
                    },
                }
            });
            this.$validator.extend('emailExist', {
                validate: async (value) => {
                    let emailExist = false;
                    await this.$axios.post('/users/check-email', {email: value}).then((response) => {
                        emailExist = response.data.emailAlreadyExists;
                    });
                    return emailExist;
                }
            });
        },
        mounted: function () {

        },
        methods: {
            clickToBack(state) {
                this.$emit("getForgotPass", state);
            },
            onCaptchaVerify() {
                this.reCaptcha.verify = true;
            },
            onCaptchaExpired() {
                this.reCaptcha.verify = false;
                this.$refs.recaptcha.reset()
            },
            forgot() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return false;

                    if (!this.reCaptcha.verify) {
                        return false;
                    }

                    this.$axios
                        .post('/users/password/reset', {
                            email: this.formForgot.email
                        })
                        .then(() => {
                            this.forgotComplete = true;
                        })
                        .catch(() => {
                            //this.forgotComplete = false;
                        });
                });
            },

        }

    }
</script>
<style lang='scss' scope="scoped">
    .container-fluid.login .right-part-wrap {
        .bottom-tip {
            width: 54%;
            display: flex;
            text-align: center;
            color: #637381;
        }
        h3 {
            font-weight: bold !important;
        }
    }

</style>
